/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Label = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 19 20">
      <path d="M18.4658,1 C18.7418,1 18.9658,1.224 18.9658,1.5 L18.9658,1.5 L18.9658,9.456 C18.9658,9.589 18.9128,9.716 18.8198,9.809 L18.8198,9.809 L8.8548,19.806 C8.7608,19.9 8.6328,19.953 8.4998,19.953 C8.3668,19.953 8.2398,19.9 8.1468,19.807 L8.1468,19.807 L0.1468,11.807 C0.0528,11.713 -0.0002,11.585 -0.0002,11.452 C-0.0002,11.319 0.0528,11.192 0.1478,11.099 L0.1478,11.099 L10.1478,1.145 C10.2408,1.053 10.3678,1 10.4998,1 L10.4998,1 Z M3.0048,9.665 L1.2078,11.454 L8.4988,18.745 L10.2888,16.949 L3.0048,9.665 Z M17.9658,2 L10.7058,2 L3.7138,8.96 L10.9948,16.241 L17.9658,9.249 L17.9658,2 Z" />
      <path d="M14.5,3.9531 C15.327,3.9531 16,4.6261 16,5.4531 C16,6.2801 15.327,6.9531 14.5,6.9531 C13.673,6.9531 13,6.2801 13,5.4531 C13,4.6261 13.673,3.9531 14.5,3.9531 Z M14.5,4.9531 C14.225,4.9531 14,5.1781 14,5.4531 C14,5.7281 14.225,5.9531 14.5,5.9531 C14.775,5.9531 15,5.7281 15,5.4531 C15,5.1781 14.775,4.9531 14.5,4.9531 Z" />
    </BaseSvgIcon>
  )
}

export default Label
